module.exports = __webpack_public_path__ + "img/202110-dark.fb8601d6.png";